import BroadcastChannel from 'broadcast-channel';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import EditSessionStore from '../common/components/containers/EditSessionProvider/EditSessionStore';
import { InternetConnectionProvider } from '../common/components/utils/InternetConnectionProvider';

import Spinner from '../common/components/utils/Spinner';
import TrackUserHistory from '../common/components/utils/TrackUserHistory';
import { getLanguage } from '../common/components/utils/Translations/helpers/makeTranslationHelpers';

import TranslationProvider from '../common/components/utils/Translations/TranslationProvider';

import withUserPreferences from '../common/data/withUserPreferences';
import { loadable } from '../common/utils/lazyLoading';
import common from './localization';

const Authentication = loadable(() => import('./Authentication'));
const Home = loadable(() => import('./Home'));

@withRouter
@withUserPreferences({
  passLoader: true,
  inline: false,
})
export default class Routes extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    ...withUserPreferences.props,
  };

  static defaultProps = {
    ...withUserPreferences.defaultProps,
  };

  componentDidMount() {
    this.loginChannel.addEventListener(
      Routes.LISTENER_TYPE,
      this.logoutEventListener,
    );
  }

  static LOGIN_BROADCAST_CHANNEL = 'login';
  static LISTENER_TYPE = 'message';
  static LOGGED_OUT_MESSAGE = 'loggedOut';

  loginChannel = new BroadcastChannel(Routes.LOGIN_BROADCAST_CHANNEL);

  logoutEventListener = e => {
    const { currentUser } = this.props;
    if (currentUser && e) {
      const { tenantId: userTenantId, message } = e;
      const { tenantId } = currentUser;
      if (message === Routes.LOGGED_OUT_MESSAGE && userTenantId === tenantId) {
        window.location = '/logout';
      }
    }
  };

  resolveLayout = isLoggedIn => {
    if (isLoggedIn) {
      return <Home />;
    } else if (!isLoggedIn) {
      return <Authentication />;
    }
  };

  render() {
    const { loading, currentUser, preferences } = this.props;

    if (loading) {
      return <Spinner fullScreen />;
    }

    const isLoggedIn = !!currentUser;

    return (
      <TrackUserHistory>
        <TranslationProvider
          language={getLanguage(preferences)}
          locale={common}
        >
          <InternetConnectionProvider>
            <EditSessionStore>
              {this.resolveLayout(isLoggedIn)}
            </EditSessionStore>
          </InternetConnectionProvider>
        </TranslationProvider>
      </TrackUserHistory>
    );
  }
}
